<template>
    <veui-dialog
        theme="ai"
        :open.sync="open"
        overlay-class="digital-human-tip-dialog"
        title="擎舵数字人能力全面升级"
        :closable="true"
        @cancel="close"
    >
        <div class="digital-human-tip-content">现已全面接入「百度一镜」数字人能力，数字人表现力与多样玩法等你体验，为营销创意提速赋能！</div>
        <template #foot>
            <veui-button ui="primary" @click="close">立即体验</veui-button>
        </template>
    </veui-dialog>
</template>

<script>
import {Dialog, Button} from 'veui';
import {getUseridFromUrl} from '@/common/util';

const STORAGE_KEY_PREFIX = 'market_asset_tip_shown_';

export default {
    name: 'DigitalHumanTipDialog',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    data() {
        return {
            open: false,
            // 当前触发弹窗的入口场景，用于区分独立的 localStorage key
            scene: ''
        };
    },
    methods: {
        storageKey(scene) {
            return `${STORAGE_KEY_PREFIX}${scene}_${getUseridFromUrl()}`;
        },
        tryShow(scene) {
            this.scene = scene;
            try {
                if (window.localStorage.getItem(this.storageKey(scene)) !== '1') {
                    this.open = true;
                }
            }
            catch (e) {
                // localStorage 不可用时静默降级
            }
        },
        close() {
            this.open = false;
            try {
                window.localStorage.setItem(this.storageKey(this.scene), '1');
            }
            catch (e) {
                // ignore
            }
        }
    }
};
</script>

<style lang="less">
.digital-human-tip-dialog {
    .veui-ai-dialog-content {
        width: 400px;
    }
    .veui-ai-dialog-content-head-title {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: @dls-color-gray-9;
    }
    .digital-human-tip-content {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 26px;
        color: @dls-color-gray-9;
    }
    .veui-ai-dialog-content-foot {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }
}
</style>
